import { useState, useEffect } from "react";
import { buildHref } from "../common/functions";
import { __ } from "@wordpress/i18n";
import Mustache from "./Mustache";

function FilterSingle({
  data,
  name,
  current,
  currFilters,
  updateQuery,
  processQuery,
  i18n = {}
}) {
  const onFilterClick = (e) => {
    //console.log(e.currentTarget);
    //return;
    updateQuery(name, e.currentTarget.id);
    processQuery();
  };

  return (
    <div className="py-2">
      <div className="filter-label py-2 font-bold uppercase">
        {i18n.filter}
      </div>
      <ul>
        {data.map((item) => {
          return (
            <div
              data-aos="fade-right"
              className="flex items-center group hover:scale-110 hover:cursor-pointer "
              onClick={onFilterClick}
              id={item.slug}
            >
              {" "}
              <div id={item.slug} 
              data-aos="fade-right" 
              className="mr-4 h-full">
                <Mustache
                  id={item.slug}
                  selected={item.selected}
                  kind={item.slug}
                ></Mustache>
              </div>
              <div
                data-aos="fade-right"
                id={item.slug}
                className={
                  "transition duration-400 uppercase filter-value  group-hover:font-bold text-black " +
                  (item.selected ? "font-bold text-primary" : "")
                }
              >
                {item.name} {" (" + item.count + ")"}
              </div>
            </div>
          );
        })}
      </ul>
    </div>
  );
}
export default FilterSingle;
